import './App.less';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { pcRouter } from './router/router_config'
import { consumeAuthCallback, loadUserProfile } from './service/auth';
import { setAuthIsLogin, setMinorMode } from './store/auth_slice/guard';
import { isMinorModeEnabled, MODE_EVENT } from './service/minorMode';

function AuthCallbackHandler() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const redirectPath = consumeAuthCallback();
    if (Cookies.get('access_token')) {
      dispatch(setAuthIsLogin(true));
      dispatch(setMinorMode(isMinorModeEnabled()));
      void loadUserProfile();
    }
    if (redirectPath && redirectPath !== window.location.pathname + window.location.search) {
      navigate(redirectPath, { replace: true });
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const syncMinorMode = (event: Event) => dispatch(setMinorMode(Boolean((event as CustomEvent).detail)));
    window.addEventListener(MODE_EVENT, syncMinorMode);
    return () => window.removeEventListener(MODE_EVENT, syncMinorMode);
  }, [dispatch]);

  return null;
}

function App() {
  return (
    <div>
       <BrowserRouter>
        <AuthCallbackHandler />
        <Routes>
          { pcRouter.map((item: any) => (
            <Route
              path={item.path}
              key={item.path}
              element={item.element}
            >
              {item.children
                ? item.children.map((i: any) => (
                  <Route
                    key={i.path}
                    index={i.index}
                    path={i.path}
                    element={i.element}
                  ></Route>
                ))
                : null}
            </Route>
          )) }
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
